var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconBlogLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 64 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.753 24.508h58.732M27.398 46.026 2.748 24.513 27.398 3",
  stroke: "currentcolor",
  strokeWidth: 4.303,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgIconBlogLeft;